import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formContainer: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
      width: "100%",
    },
    olPaper: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(12),
      marginBottom: theme.spacing(12),
    },
    header: {
      color: theme.gray800,
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      marginBottom: theme.spacing(8),
    },
    addHeaderButton: {
      padding: theme.spacing(1.5, 8),
      alignSelf: "start",
    },
    headerRemoveButton: {
      marginTop: theme.spacing(8),
      height: "24px",
      width: "24px",
      backgroundColor: theme.gray100,
      color: theme.gray400,
      padding: 0,
      "&:hover": {
        backgroundColor: theme.gray100,
      },
    },
    icon: { color: theme.primary500 },
  }),
);
